import React from 'react';
import { Store } from 'lucide-react';
import ServiceTemplate from './ServiceTemplate';

const FranchisePage = () => {
  const serviceData = {
    icon: Store,
    nameAr: 'دائرة الامتياز التجاري',
    nameEn: 'Franchise Department',
    taglineAr: 'حلول قانونية متكاملة للامتياز التجاري',
    taglineEn: 'Comprehensive legal solutions for commercial franchising',
    
    descriptionAr: [
      'دائرة الامتياز التجاري في وازن متخصصة في تقديم خدمات قانونية متكاملة لأنظمة الامتياز التجاري (Franchise). سواءً كنت مانح امتياز (Franchisor) أو ممنوح له (Franchisee)، نقدم لك الدعم القانوني الشامل.',
      'نساعد في بناء أنظمة امتياز قوية تحمي حقوق جميع الأطراف، ونضمن التوافق مع نظام الامتياز التجاري السعودي وجميع المتطلبات القانونية.'
    ],
    descriptionEn: [
      'Wazin\'s Franchise Department specializes in providing comprehensive legal services for franchise systems. Whether you are a franchisor or franchisee, we provide you with comprehensive legal support.',
      'We help build strong franchise systems that protect the rights of all parties, and ensure compliance with the Saudi Commercial Franchise Law and all legal requirements.'
    ],

    services: [
      {
        nameAr: 'إعداد وثائق الامتياز التجاري (Franchise Disclosure Documents)',
        nameEn: 'Preparing Franchise Disclosure Documents',
        descAr: 'إعداد جميع وثائق الإفصاح المطلوبة لنظام الامتياز التجاري وفق المعايير المحلية والدولية',
        descEn: 'Preparing all required disclosure documents for franchise system according to local and international standards'
      },
      {
        nameAr: 'إعداد وصياغة عقود الامتياز التجاري بما يحقق حماية الحقوق للطرفين',
        nameEn: 'Preparing franchise contracts ensuring rights protection for both parties',
        descAr: 'صياغة عقود امتياز تجاري متوازنة تحمي حقوق مانح الامتياز والممنوح',
        descEn: 'Drafting balanced franchise contracts protecting rights of franchisor and franchisee'
      },
      {
        nameAr: 'مراجعة وتدقيق وثائق وعقود الامتياز التجاري القائمة',
        nameEn: 'Reviewing and auditing existing franchise documents and contracts',
        descAr: 'فحص وتدقيق عقود ووثائق الامتياز التجاري القائمة للتأكد من سلامتها النظامية',
        descEn: 'Examining and auditing existing franchise contracts and documents to ensure legal soundness'
      },
      {
        nameAr: 'إنهاء إجراءات تسجيل الامتياز التجاري لدى الجهات المختصة',
        nameEn: 'Completing franchise registration procedures with competent authorities',
        descAr: 'متابعة وإنهاء جميع إجراءات تسجيل الامتياز التجاري لدى وزارة التجارة',
        descEn: 'Following up and completing all franchise registration procedures with Ministry of Commerce'
      },
      {
        nameAr: 'إعداد أدلة التشغيل (Operations Manuals) بالتنسيق مع المستفيد',
        nameEn: 'Preparing Operations Manuals in coordination with beneficiary',
        descAr: 'إعداد أدلة التشغيل والإجراءات الخاصة بنظام الامتياز التجاري',
        descEn: 'Preparing operations manuals and procedures for franchise system'
      },
      {
        nameAr: 'معالجة المخالفات والنزاعات المتعلقة بعقود الامتياز التجاري، وتمثيل الأطراف عند الحاجة',
        nameEn: 'Handling violations and disputes related to franchise contracts and representing parties',
        descAr: 'حل النزاعات بين مانح الامتياز والممنوحين وتمثيل الأطراف قانونياً عند الضرورة',
        descEn: 'Resolving disputes between franchisor and franchisees and legally representing parties when necessary'
      }
    ],

    specializations: [
      { ar: 'امتياز المطاعم', en: 'Restaurant Franchise' },
      { ar: 'امتياز التجزئة', en: 'Retail Franchise' },
      { ar: 'امتياز الخدمات', en: 'Service Franchise' },
      { ar: 'امتياز التعليم', en: 'Education Franchise' },
      { ar: 'امتياز الصحة والجمال', en: 'Health & Beauty Franchise' },
      { ar: 'الامتياز الدولي', en: 'International Franchise' },
      { ar: 'امتياز الأغذية والمشروبات', en: 'Food & Beverage Franchise' },
      { ar: 'امتياز التقنية', en: 'Technology Franchise' },
      { ar: 'امتياز الضيافة', en: 'Hospitality Franchise' },
      { ar: 'امتياز السيارات', en: 'Automotive Franchise' }
    ],

    faqs: [
      {
        questionAr: 'ما هي متطلبات تسجيل الامتياز؟',
        questionEn: 'What are the requirements for franchise registration?',
        answerAr: 'يتطلب تسجيل الامتياز: عقد الامتياز، دليل العمليات، تسجيل العلامة التجارية، وثائق الشركة، ومستندات الإفصاح. نقوم بإعداد جميع هذه المستندات وفق المتطلبات النظامية.',
        answerEn: 'Franchise registration requires: franchise agreement, operations manual, trademark registration, company documents, and disclosure documents. We prepare all these documents according to legal requirements.'
      },
      {
        questionAr: 'كم يستغرق تسجيل نظام الامتياز؟',
        questionEn: 'How long does franchise system registration take?',
        answerAr: 'يستغرق عادةً من شهر إلى شهرين لإعداد وتسجيل نظام امتياز متكامل، حسب جاهزية الوثائق وسرعة الإجراءات الحكومية.',
        answerEn: 'It usually takes one to two months to prepare and register a complete franchise system, depending on document readiness and speed of government procedures.'
      },
      {
        questionAr: 'ما الفرق بين الامتياز والوكالة التجارية؟',
        questionEn: 'What is the difference between franchise and commercial agency?',
        answerAr: 'الامتياز يمنح حق استخدام العلامة والنظام التشغيلي الكامل، بينما الوكالة التجارية تقتصر على توزيع منتجات أو خدمات محددة. الامتياز أشمل وأعمق من الوكالة.',
        answerEn: 'Franchise grants the right to use the brand and complete operational system, while commercial agency is limited to distributing specific products or services. Franchise is more comprehensive and deeper than agency.'
      },
      {
        questionAr: 'هل يمكن تعديل عقد الامتياز؟',
        questionEn: 'Can the franchise contract be amended?',
        answerAr: 'نعم، يمكن تعديل عقد الامتياز بموافقة جميع الأطراف وفق الإجراءات النظامية. نساعد في صياغة وتوثيق التعديلات بطريقة قانونية سليمة.',
        answerEn: 'Yes, the franchise contract can be amended with the consent of all parties according to legal procedures. We help draft and document amendments in a sound legal manner.'
      }
    ]
  };

  return <ServiceTemplate serviceData={serviceData} />;
};

export default FranchisePage;